import { 
  Building2, 
  Trees, 
  Waves, 
  Shield, 
  Dumbbell, 
  Car,
  Baby,
  Utensils,
  Sparkles,
  Camera,
  AirVent,
  ChefHat,
  Plane,
  ShoppingBag,
  MapPin,
  Eye
} from "lucide-react";

export default function FeaturesSection() {
  const features = {
    exterior: [
      { icon: Car, label: "Closed Car Park" },
      { icon: Trees, label: "Communal Garden" },
      { icon: Waves, label: "Communal Pool" },
      { icon: Building2, label: "Concierge Service" },
      { icon: Dumbbell, label: "Fitness Center" },
      { icon: Baby, label: "Playground" },
      { icon: Utensils, label: "Restaurant & Cafe" },
      { icon: Shield, label: "24/7 Security" },
      { icon: Camera, label: "Security Camera" },
      { icon: Sparkles, label: "SPA" }
    ],
    interior: [
      { icon: AirVent, label: "Air Conditioning" },
      { icon: ChefHat, label: "Kitchen Appliances" }
    ],
    location: [
      { icon: Plane, label: "Airport (15-30 Km)" },
      { icon: Utensils, label: "Bars & Restaurants" },
      { icon: MapPin, label: "Close to Golf Courses" },
      { icon: Eye, label: "Sea View" },
      { icon: ShoppingBag, label: "Shopping Malls" }
    ]
  };

  return (
    <section className="py-20 bg-background">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Luxury Living in the Dubai Property Market
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
              This international property investment in Dubai offers world-class amenities, making it a prime Dubai residential investment for expats and global citizens.
            </p>
          </div>

          {/* Exterior Features */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-foreground flex items-center gap-3">
              <Building2 className="w-7 h-7 text-primary" />
              Community Features for a High-Quality Lifestyle
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {features.exterior.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div 
                    key={index}
                    className="flex flex-col items-center text-center p-4 bg-card rounded-lg border border-border hover:border-primary/50 transition-colors"
                  >
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <span className="text-sm font-medium text-card-foreground">{feature.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Interior Features */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-foreground flex items-center gap-3">
              <AirVent className="w-7 h-7 text-primary" />
              Premium Interior Finishes
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {features.interior.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div 
                    key={index}
                    className="flex flex-col items-center text-center p-4 bg-card rounded-lg border border-border hover:border-primary/50 transition-colors"
                  >
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <span className="text-sm font-medium text-card-foreground">{feature.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Location Features */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-foreground flex items-center gap-3">
              <MapPin className="w-7 h-7 text-primary" />
              Unbeatable Location for Your Dubai Investment
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {features.location.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div 
                    key={index}
                    className="flex flex-col items-center text-center p-4 bg-card rounded-lg border border-border hover:border-primary/50 transition-colors"
                  >
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <span className="text-sm font-medium text-card-foreground">{feature.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Location Description */}
          <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl p-8 border border-primary/10">
            <h3 className="text-2xl font-bold mb-4 text-foreground">Strategic Location in Motor City</h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Strategically positioned in the heart of the Dubai real estate 2024 boom, this tax-free property Dubai offers a unique Dubai investment opportunity. With easy access to key landmarks, it's the perfect expat property in Dubai.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              The upcoming metro line further enhances its value, solidifying its status as a top-tier international property investment in Dubai.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
